import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AbstractTool} from 'app/tool-layer/class/abstract-tool';
import {SvgOptionInterface} from 'app/component/svg-input/svg-input.component';
import {SvgElementsEnum} from 'app/enum/svg.enum';

@Component({
    selector: 'app-number-line',
    templateUrl: './number-line.component.html',
    styleUrls: ['./number-line.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class NumberLineComponent extends AbstractTool {
    public static readonly id = 'getallenlijn';
    public static readonly width = 1024;
    public static readonly height = 57.5;

    public length = '0_100';
    public showMarkers = true;
    public showNumbers = true;
    public showUnits = true;
    public numberLineOptions = [
        ['0', '100'],
        ['0', '10.000'],
        ['0', '1000'],
        ['0', '100.000'],
    ];

    public svgList: SvgOptionInterface[] = [
        {
            path: SvgElementsEnum.Label,
            icon: 'fas fa-tag',
        },
    ];
}
